import { includes, pull, concat } from "lodash"

import APIs from "redux/apis"
import { PAGE_NUM } from "config/const"
import { APIResponse } from "redux/apis/types"

// 銘柄検索機能

type SearchParams = {
  _take: number
  _skip: number
  keyword?: string
  Markets?: string
}

export type searchSymbolType = {
  Symbol?: string
  Exchange?: string | number
  SecurityType?: string | number
}

export type searchStateType = {
  isHover?: boolean
  isInputting?: boolean
  isOpenModal?: boolean
  isSelectSymbol?: boolean
  isOpenSelectCountry?: boolean
  value?: searchSymbolType | null
  searchValue?: string
  selectCountries?: Array<number>
  selectTab?: string | null
}

export type searchActionType = {
  type:
    | "SEARCH_HOVER"
    | "SEARCH_INPUTTING"
    | "SEARCH_OPEN_MODAL"
    | "SEARCH_OPEN_COUNTRY"
    | "SEARCH_CHANGE_VALUE"
    | "SEARCH_CHANGE_SELECT_SYMBOL"
    | "SEARCH_SELECT_COUNTRY"
    | "SEARCH_SELECT_PROPS_COUNTRY"
    | "SEARCH_SELECT_ALL_COUNTRY"
    | "SEARCH_SELECT_TAB"
    | "SEARCH_EXECUTE"
    | "SEARCH_SELECT_DOMESTIC"
    | "SEARCH_SELECT_FOREIGN"
  value?: string
  selectSymbol?: number
  selectCountry?: number
  allCountry?: Array<number>
  selectTab?: string
  action?: boolean
  symbol?: APIResponse.Res
}

export const useSearchActionReducer = (executeAction: Function) => (
  state: searchStateType,
  action: searchActionType
) => {
  switch (action.type) {
    case "SEARCH_HOVER":
      return { ...state, isHover: action.action }
    case "SEARCH_INPUTTING":
      return { ...state, isInputting: action.action, selectSymbol: null }
    case "SEARCH_OPEN_MODAL":
      return {
        ...state,
        isOpenModal: action.action,
        isOpenSelectCountry: false,
        isHover: false,
        isInputting: false,
      }
    case "SEARCH_OPEN_COUNTRY":
      return {
        ...state,
        isOpenSelectCountry: true,
        isOpenModal: true,
        isHover: false,
        isInputting: false,
      }
    case "SEARCH_CHANGE_VALUE":
      return { ...state, searchValue: action.value, selectSymbol: null }
    case "SEARCH_CHANGE_SELECT_SYMBOL":
      return { ...state, selectSymbol: action.selectSymbol }
    case "SEARCH_SELECT_COUNTRY":
      let select: Array<number> = []
      if (includes(state.selectCountries, action.selectCountry)) {
        if (state.selectCountries.length === 1) return state
        select = pull(state.selectCountries, action.selectCountry)
      } else {
        select = concat(state.selectCountries, action.selectCountry)
      }
      return { ...state, selectCountries: select }
    case "SEARCH_SELECT_ALL_COUNTRY":
      if (state.selectCountries.length === action.allCountry.length) {
        return {
          ...state,
          selectCountries: [0],
        }
      } else {
        return { ...state, selectCountries: action.allCountry }
      }
    case "SEARCH_SELECT_PROPS_COUNTRY":
      return { ...state, selectCountries: action.allCountry }
    case "SEARCH_SELECT_TAB":
      return state
    case "SEARCH_EXECUTE":
      //確実にモーダルが閉じてからExecuteするようにする。時間はひとまず
      setTimeout(() => executeAction(action.symbol), 500)
      return {
        ...state,
        isOpenModal: false,
        isOpenSelectCountry: false,
        isHover: false,
        isInputting: false,
      }
    case "SEARCH_SELECT_DOMESTIC":
      return { ...state, selectCountries: [0] }
    case "SEARCH_SELECT_FOREIGN":
      let _select = []
      for (let i = 1; i < 12; i++) _select.push(i)
      return { ...state, selectCountries: _select }
    default:
      return state
  }
}

export const SearchDetailFunction = async (
  page: number,
  key?: string,
  market?: string,
  chartFlag?: boolean
) => {
  const params: SearchParams = {
    _skip: !chartFlag ? PAGE_NUM.PAGE_20 * page : PAGE_NUM.PAGE_10 * page,
    _take: !chartFlag ? PAGE_NUM.PAGE_20 : PAGE_NUM.PAGE_10,
  }
  if (!!key) params["keyword"] = key
  if (!!market) params["Markets"] = market
  const res = await APIs.SymbolDetail.EquitySymbolList(params)
  return res
}
